import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import brandMessages from "@faire/web-api--source/routes/brand-portal/messages";
import { route as messagesRoute } from "@faire/web-api--source/routes/messages";
import insiderMembership from "@faire/web-api--source/routes/retailer/settings/insider-membership";
import paymentMethods from "@faire/web-api--source/routes/retailer/settings/payment-methods";
import insiderMembershipInfo from "@faire/web-api--source/routes/user/insider/info";
import isUndefined from "lodash/isUndefined";
import qs from "query-string";
import { matchPath } from "react-router-dom";
export var isPathMatch = function(pathname, pathToMatch) {
    var exact = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return matchPath(pathname, {
        path: pathToMatch,
        exact: exact
    });
};
// Cannot use parse since it is not deterministic
export var getQueryParts = function(query) {
    var processedQuery = query.toLowerCase();
    if (processedQuery[0] === "?") {
        processedQuery = processedQuery.slice(1);
    }
    return processedQuery.split("&");
};
/**
 * @deprecated
 *
 * Redirect rules are an old pattern for matching location path changes
 * and redirecting to a new location when that happens. Many of the below redirects
 * are no longer needed and should be removed.
 *
 * All new redirects should use the standard react-router-dom <Redirect /> component
 * in order to redirect old paths to new ones.
 */ export var redirectRules = [
    function(pathname, query) {
        var matchedPath = isPathMatch(pathname, "/user/account/payments");
        if (matchedPath !== null) {
            return "".concat(paymentMethods()).concat(query !== null && query !== void 0 ? query : "");
        }
        return null;
    },
    function(pathname) {
        var matchedPath = isPathMatch(pathname, "/user/boom");
        if (matchedPath !== null) {
            return insiderMembership();
        }
        return null;
    },
    function(pathname) {
        var matchedPath = isPathMatch(pathname, "/user/boom/info");
        if (matchedPath !== null) {
            return insiderMembershipInfo();
        }
        return null;
    },
    function(pathname) {
        var matchedPath = isPathMatch(pathname, messagesRoute);
        if (matchedPath !== null && isUndefined(RetailerStore.get().retailer) && !isUndefined(UserStore.get().user)) {
            return brandMessages();
        }
        return null;
    },
    function(pathname) {
        var matchedPath = isPathMatch(pathname, "/brand-onboarding", false) || isPathMatch(pathname, "/:locale/brand-onboarding", false) && !isPathMatch(pathname, "/brand-portal/brand-onboarding", false);
        if (matchedPath) {
            return "/brand-portal/brand-onboarding";
        }
        return null;
    },
    function(pathname, query) {
        var matchedPath = isPathMatch(pathname, "/brand/:brandToken") || isPathMatch(pathname, "/retailer/:retailerToken/brand/:brandToken");
        var queryObj = qs.parse(query);
        if (matchedPath && queryObj.fromC) {
            return "".concat(pathname, "?").concat(qs.stringify(_object_spread_props(_object_spread({}, queryObj), {
                fromC: undefined,
                sortingHint: true
            })));
        }
        return null;
    }
];
